import { useQuery } from 'react-query';
import { useDebounce } from 'use-debounce';
import { backend } from '../axios/backend';
import Input from './ui/Input';
import Spinner from './ui/Spinner';

type UrlValue = { url: string; imageUrl?: string };

type UrlInputProps = {
  value: UrlValue;
  name: string;
  isDisabled?: boolean;
  type?: React.HTMLInputTypeAttribute;
  placeholder?: string;
  isTextArea?: boolean;
  isRequired?: boolean;
  onChange: (newValue: UrlValue) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
};

const UrlInput = (props: UrlInputProps) => {
  const [debouncedValue] = useDebounce(props.value.url, 500);

  const previewQuery = useQuery(
    ['image-preview', debouncedValue],
    async () =>
      (
        await backend.get<string[]>(`/image/preview-images`, {
          params: {
            productUrl: debouncedValue,
          },
        })
      ).data,
    { onSuccess: (data) => console.log(data) },
  );

  return (
    <div className="space-y-2">
      <Input
        name={props.name}
        value={props.value.url}
        onBlur={props.onBlur}
        onChange={(e) => props.onChange({ ...props.value, url: e.target.value })}
        placeholder={props.placeholder}
        isDisabled={props.isDisabled}
        isRequired={props.isRequired}
      />
      <div className="flex flex-row space-x-2 items-center">
        {previewQuery.isLoading && (
          <span className="flex flex-row space-x-1 text-xs items-center">
            <Spinner size={6} />
            <span className="text-gray-300">Lade Vorschau...</span>
          </span>
        )}
        {previewQuery.data?.map((previewUrl) => (
          <div
            style={
              previewUrl
                ? {
                    backgroundImage: `url(${previewUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }
                : undefined
            }
            className={`h-10 w-10 rounded-full shrink-0 ${
              previewUrl === props.value.imageUrl ? 'border-4 border-lime-600' : ''
            }`}
            onClick={() => props.onChange({ ...props.value, imageUrl: previewUrl })}
          />
        ))}
      </div>
    </div>
  );
};

export default UrlInput;
